import React, { useEffect, useRef, useState } from "react";
import { FaGlobeAmericas, FaMapMarkerAlt, FaHandHoldingHeart } from "react-icons/fa";

const INTERVALO_MS = 6000;

const formatoFecha = (fecha) =>
  fecha
    ? new Date(fecha).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" })
    : "";

const formatoMoneda = (numero) =>
  Number(numero || 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 0 });

export default function Misioneros() {
  const [misioneros, setMisioneros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [indice, setIndice] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const cargar = async () => {
      try {
        const res = await fetch("/api/misioneros/activos", {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Error obteniendo misioneros");
        setMisioneros(await res.json());
      } catch (err) {
        console.error("Error cargando misioneros:", err);
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, []);

  useEffect(() => {
    if (misioneros.length <= 1) return;
    timerRef.current = setInterval(() => {
      setIndice((prev) => (prev + 1) % misioneros.length);
    }, INTERVALO_MS);
    return () => clearInterval(timerRef.current);
  }, [misioneros.length]);

  const actual = misioneros[indice];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <div className="flex items-center gap-2 mb-4">
        <span className="w-8 h-8 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center">
          <FaGlobeAmericas />
        </span>
        <h2 className="text-base font-semibold text-slate-800">Misioneros</h2>
      </div>

      {loading ? (
        <p className="text-sm text-slate-400 text-center py-10">Cargando misioneros...</p>
      ) : misioneros.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-10">No hay misioneros activos por el momento.</p>
      ) : (
        <div>
          <div className="relative w-full h-64 rounded-lg overflow-hidden bg-slate-100">
            {actual.imagen ? (
              <img
                key={actual.id_misionero}
                src={`${actual.imagen}`}
                alt={actual.nombre}
                className="w-full h-full object-contain animate-fadeIn"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <FaGlobeAmericas className="text-4xl text-slate-300" />
              </div>
            )}

            <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-slate-900/80 to-transparent px-4 pt-8 pb-3 text-white">
              <p className="text-sm font-semibold">{actual.nombre}</p>
              <p className="text-xs text-slate-200">{actual.titulo}{actual.es_de_casa ? " · De casa" : ""}</p>
            </div>
          </div>

          <div className="mt-3 space-y-1.5">
            {(actual.lugar_llamado || actual.pais) && (
              <p className="flex items-center gap-1.5 text-xs text-slate-500">
                <FaMapMarkerAlt className="text-slate-400 shrink-0" />
                {[actual.lugar_llamado, actual.pais].filter(Boolean).join(" · ")}
              </p>
            )}
            <p className="flex items-center gap-1.5 text-xs text-slate-500">
              <FaHandHoldingHeart className="text-slate-400 shrink-0" />
              Apoyo mensual: ${formatoMoneda(actual.cantidad_apoyo_mensual)}
              {actual.fecha_inicio && ` · Desde ${formatoFecha(actual.fecha_inicio)}`}
            </p>
          </div>

          {misioneros.length > 1 && (
            <div className="flex justify-center gap-1.5 mt-3">
              {misioneros.map((m, i) => (
                <button
                  key={m.id_misionero}
                  onClick={() => setIndice(i)}
                  aria-label={`Ver a ${m.nombre}`}
                  className={`h-1.5 rounded-full transition-all ${
                    i === indice ? "w-5 bg-indigo-600" : "w-1.5 bg-slate-200 hover:bg-slate-300"
                  }`}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
